import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import InternalStakeholderAvailabilityEvent from "../event/InternalStakeholderAvailabilityEvent";
import InternalStakeholderInteractionEvent from "../event/InternalStakeholderInteractionEvent";
import InternalStakeholderDefinition from "../model/InternalStakeholderDefinition";
import InternalStakeholdersModel from "../model/InternalStakeholdersModel";
import InternalStakeholderButton from "./InternalStakeholderButton";

export default class InternalStakeholdersMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {LayoutManager} layoutManager 
     * @param {RevisableLanguagePack} languagePack 
     * @param {InternalStakeholdersModel} internalStakeholdersModel 
     */
    constructor(target, dispatcher, clickEaterFactory, layoutManager, languagePack, internalStakeholdersModel) {
        super(target, dispatcher, clickEaterFactory, layoutManager);

        this._languagePack = languagePack;
        this._internalStakeholdersModel = internalStakeholdersModel;

        this._internalStakeholderButtons = [];

        this._handleInternalStakeholderButtonBound = this._handleInternalStakeholderButton.bind(this);
    }

    initialize() {
        super.initialize();

        this._initializeStakeholderButtons();

        this.registerEventListener(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_AVAILABLE, this._handleInternalStakeholderAvailable.bind(this));
        this.registerEventListener(InternalStakeholderAvailabilityEvent.INTERNAL_STAKEHOLDER_UNAVAILABLE, this._handleInternalStakeholderUnavailable.bind(this));
    }

    destroy() {
        super.destroy();

        for (let i = 0; i < this._internalStakeholderButtons.length; i++) {
            const internalStakeholderButton = this._internalStakeholderButtons[i];
            internalStakeholderButton.removeEventListener('click', this._handleInternalStakeholderButtonBound);
            internalStakeholderButton.setData(null);
            internalStakeholderButton.destroy();
        }
    }

    _initializeStakeholderButtons() {
        for (let i = 0; i < this._internalStakeholdersModel.internalStakeholders.length; i++) {
            const internalStakeholder = this._internalStakeholdersModel.internalStakeholders[i];
            const buttonSkin = this._target[`internalStakeholder${i + 1}`];
            if (!buttonSkin) {
                continue;
            }

            const button = new InternalStakeholderButton(buttonSkin);
            button.setNameLabel(this._languagePack.getText(`internalStakeholders.${internalStakeholder.id}.name`));
            button.setPositionLabel(this._languagePack.getText(`internalStakeholders.${internalStakeholder.id}.position`));
            button.addEventListener('click', this._handleInternalStakeholderButtonBound);
            button.setData({
                internalStakeholder,
            });

            const internalStakeholderIsActive = this._internalStakeholdersModel.internalStakeholderIsActive(internalStakeholder);
            button.setEnabled(internalStakeholderIsActive);

            this._internalStakeholderButtons.push(button);
        }
    }

    /**
     * @param {InternalStakeholderDefinition} internalStakeholder 
     * @return {Button}
     */
    _getButtonForInternalStakeholder(internalStakeholder) {
        return this._internalStakeholderButtons.find(b => b.getData()?.internalStakeholder === internalStakeholder);
    }

    _handleInternalStakeholderButton(evt) {
        const data = evt?.target?.getData();
        /** @type {InternalStakeholderDefinition} */
        const internalStakeholder = data?.internalStakeholder;

        const internalStakeholderEvent = new InternalStakeholderInteractionEvent(InternalStakeholderInteractionEvent.REQUEST_CONVERSATION, internalStakeholder);
        this.dispatch(internalStakeholderEvent.type, { data: internalStakeholderEvent });
    }

    _handleInternalStakeholderAvailable(evt) {
        const data = evt.params.data;
        const internalStakeholder = data?.internalStakeholder;

        const button = this._getButtonForInternalStakeholder(internalStakeholder);
        button.setEnabled(true);
    }

    _handleInternalStakeholderUnavailable(evt) {
        const data = evt.params.data;
        const internalStakeholder = data?.internalStakeholder;

        const button = this._getButtonForInternalStakeholder(internalStakeholder);
        button.setEnabled(false);
    }
}